import { createSlice } from '@reduxjs/toolkit';
import { processVisitData } from 'utils';
import { createAsyncAction } from '../action/index';

const getPrescriptions = createAsyncAction('getPrescriptions', 'getPrescriptions');
const getPrescriptionPdf = createAsyncAction('getPrescriptionPdf', 'getPrescriptionPdf');
const diagnosticOrder = createAsyncAction('diagnosticOrder', 'diagnosticOrder');
const getDiscountBanner = createAsyncAction('getDiscountBanner', 'getDiscountBanner');
const getCartItems = createAsyncAction('getCartItems', 'getCartItems');

interface InitialState {
  visits: any[],
  prescriptionPdf: string,
  visitByYear: any;
  years: any[];
  bannerByType: any;
  cartItems: any,
  isFetchingPrescription: boolean,
  isFetchingPrescriptionPdf: boolean,
  isFetchingBanners: boolean,
  isFetchingCartItems: boolean,
  orderStatus: string,
}

const initialState = {
  visits: [],
  visitByYear: {},
  years: [],
  prescriptionPdf: '',
  cartItems: {},
  isFetchingPrescription: true,
  isFetchingPrescriptionPdf: false,
  isFetchingBanners: false,
  isFetchingCartItems: false,
  orderStatus: '',
  bannerByType: {},
} as InitialState;

export const counterSlice = createSlice({
  name: 'prescription',
  initialState,
  reducers: {
    resetOrderStatus(state) {
      state.orderStatus = '';
    },
  },
  extraReducers: {
    [getPrescriptions.pending as any]: (state) => {
      state.isFetchingPrescription = true;
      state.visits = [];
      state.visitByYear = {};
      state.years = [];
    },
    [getPrescriptions.fulfilled as any]: (state, { payload }) => {
      const visits = payload?.visits || payload?.user?.visit || [];
      const processData = processVisitData(visits);
      state.visits = processData.visits;
      state.visitByYear = processData.visitByYear;
      state.years = processData.years;
      state.isFetchingPrescription = false;
    },
    [getPrescriptions.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingPrescription = false;
    },
    [getPrescriptionPdf.pending as any]: (state) => {
      state.isFetchingPrescriptionPdf = true;
      state.prescriptionPdf = '';
    },
    [getPrescriptionPdf.fulfilled as any]: (state, { payload }) => {
      state.isFetchingPrescriptionPdf = false;
      state.prescriptionPdf = payload.url;
    },
    [getPrescriptionPdf.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingPrescriptionPdf = false;
    },
    [diagnosticOrder.pending as any]: (state) => {
      state.orderStatus = 'pending';
    },
    [diagnosticOrder.fulfilled as any]: (state) => {
      state.orderStatus = 'success';
    },
    [diagnosticOrder.rejected as any]: (state) => {
      state.orderStatus = 'error';
    },
    [getDiscountBanner.pending as any]: (state) => {
      state.isFetchingBanners = true;
      state.bannerByType = {};
    },
    [getDiscountBanner.fulfilled as any]: (state, { payload }) => {
      state.bannerByType = payload;
      state.isFetchingBanners = false;
    },
    [getDiscountBanner.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingBanners = false;
    },
    [getCartItems.pending as any]: (state) => {
      state.isFetchingCartItems = true;
      state.cartItems = {};
    },
    [getCartItems.fulfilled as any]: (state, { payload }) => {
      state.cartItems = payload;
      state.isFetchingCartItems = false;
    },
    [getCartItems.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingCartItems = false;
    },
  },
});

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount, } = counterSlice.actions
const { resetOrderStatus } = counterSlice.actions;
export {
  getPrescriptions,
  getPrescriptionPdf,
  diagnosticOrder,
  resetOrderStatus,
  getDiscountBanner,
  getCartItems,
};
export default counterSlice.reducer;